'use client';

import dynamic from 'next/dynamic';

const MoonAnimation = dynamic(() => import('../MoonAnimation'), { ssr: false });

export default function MoonAnimationClient() {
  return <MoonAnimation />;
}
